import React, {CSSProperties, useEffect, useMemo, useState} from 'react';
import { usePage } from '@inertiajs/react';
import { defaultJmsColor, isCheckColorWhite } from '@Utils/colorUtils';

export function useDynamicButtonStyle(themeButtonStyleProps?: React.CSSProperties | undefined) {
  const { props } = usePage();
  const auth = props?.auth as Auth | undefined;
  const bannerColor = auth?.company?.settings?.banner_color || defaultJmsColor;
  const [colorButton, setColorButton] = useState<string>(bannerColor);
  useEffect(() => {
    if (isCheckColorWhite(bannerColor)) {
      setColorButton(defaultJmsColor);
    } else {
      setColorButton(bannerColor);
    }
  }, [bannerColor]);
  return useMemo<CSSProperties>(() => {
    const base = themeButtonStyleProps ?? {};
    return { ...base, background: colorButton };
  }, [themeButtonStyleProps, colorButton]);
}
